export default __webpack_public_path__ + "static/1847-874afbbbe0efd34998d9c0c5227bcb30.gif";